"use client";

import {
  Navbar,
  Nav,
  Container,
  Offcanvas,
  Button,
} from "react-bootstrap";

import Link from "next/link";
import Image from "next/image";
import { useEffect, useState } from "react";
import { FaAngleDown } from "react-icons/fa";

import styles from "./NavbarSection.module.css";
import Logo from "@/app/assets/logo.svg";

import { Sparkles } from "lucide-react";


 // Main categories
import aiHostingIcon from "@/app/assets/icon/01 ai hosting.png";
import gpuServerIcon from "@/app/assets/icon/02 gpu server.png";
import whisperIcon from "@/app/assets/icon/03 whisdper.png";

// LLM & AI models
 
import ollamaIcon from "@/app/assets/icon/04 ollama.png";
import deepseekIcon from "@/app/assets/icon/05 deepseek.png";
import mistralIcon from "@/app/assets/icon/06 mistral.png";
import llamaIcon from "@/app/assets/icon/07 llama.png";
import vllmIcon from "@/app/assets/icon/08 vllm.png";
import lmStudioIcon from "@/app/assets/icon/09 lm-studio.png";
import gemmaIcon from "@/app/assets/icon/10 gemma.png";
import phiIcon from "@/app/assets/icon/11 phi.png";
import barkIcon from "@/app/assets/icon/13 bark.png";
import openaiIcon from "@/app/assets/icon/16 openai.png";

// Extended LLMs
import qwenIcon from "@/app/assets/icon/14 qwen.png";
import qwen3Icon from "@/app/assets/icon/15 qwen3.png";

// Image & media AI
import stableDiffusionIcon from "@/app/assets/icon/17-stable-diffusion.png";
import xttsIcon from "@/app/assets/icon/18 xtts.png";
import ttsHostingIcon from "@/app/assets/icon/18 xtts.png";
import coquiIcon from "@/app/assets/icon/19 coqui-log.png";
import chatterboxIcon from "@/app/assets/icon/20 chatterbox.png";
import wanIcon from "@/app/assets/icon/21 wan.png";
import comfyUIIcon from "@/app/assets/icon/22 ComfyUI.png";

// Frameworks
import tensorflowIcon from "@/app/assets/icon/23 tensorslow.png";
import pytorchIcon from "@/app/assets/icon/24 pytourch.png";
import kerasIcon from "@/app/assets/icon/25 keras.png";

// Vector DB & OCR
import milvusIcon from "@/app/assets/icon/26 Milvus.png";
import chromaIcon from "@/app/assets/icon/27 chroma.png";
import qdrantIcon from "@/app/assets/icon/28 qdrant.png";
import paddleOCRIcon from "@/app/assets/icon/29 Paddlepaddle.png";
import kokoroIcon from "@/app/assets/icon/30-kokorotts.png";
import llMIcon from "@/app/assets/icon/31-llm.png";
import fluxHostingIcon from "@/app/assets/icon/32-flux.png";


import { StaticImageData } from "next/image";

type MegaMenuItem = [
  StaticImageData, // icon
  string,          // title
  string,          // description
  string           // url
];

/* ---------------------------------------------------------
   MENU DATA (WITH ICONS)
--------------------------------------------------------- */

// Infrastructure Hosting
const infraHosting: [string, string, string, string, string?][] = [
  [
    "/ad4.svg",
    "Managed Dedicated Servers",
    "High-performance servers with full management.",
    "",
    "/dedicated-servers-usa",
  ],
  [
    "/pr1.svg",
    "Managed Cloud Hosting",
    "High-availability cloud hosting with full management.",
    "AI-POWERED",
    "/managed-cloud-hosting",
  ],
  [
    "/pr3.svg",
    "Virtual Machines",
    "Flexible VMs with full control for apps and websites.",
    " ",
    "/linux-virtual-private-server-vps-usa",
  ],


  [
    "/hos3.svg",
    "Linux Reseller Hosting",
    "Scalable Linux reseller hosting for your clients.",
    " ",
    "/linux-reseller-hosting-usa",
  ],
  [
    "/hos5.svg",
    "Linux SEO Hosting",
    "Multi-IP SEO hosting for speed and rankings.",
    " ",
    "/linux-seo-hosting",
  ],
  [
    "/hos4.svg",
    "Windows Reseller Hosting",
    "Resell Windows hosting with WHMCS support.",
    " ",
    "/windows-reseller-hosting-usa",
  ],

];

// Networking (without domain items)
const networking: [string, string, string, string][] = [
  [
    "/ad2.svg",
    "Acronis Cyber Protect",
    "Advanced cyber protection with backup, disaster recovery, and security in one unified platform.",
    "/acronis-cyber-protect-cloud",
  ],
  [
    "/ggl1.svg",
    "Google Workspace",
    "Secure business email, cloud storage, and collaboration tools powered by Google for modern teams.",
    "/buy-google-workspace",
  ],
  [
    "/pr4.svg",
    "Networking",
    "Managed databases for fast, secure, scalable data handling.",
    "/managed-mongodb-hosting",
  ],
    ["/ad1.svg", "Proxies", "High-speed proxies for secure browsing.", "/proxies"],
  ["/ad3.svg", "VPN", "Private VPN service for online protection.", "/vpn"],
];

// Apps
const apps: [string, string, string, string ][] = [ 
  [
    "/hos1.svg",
    "Linux Shared Hosting",
    "Fast & reliable shared hosting for websites.", 
    "/linux-shared-hosting-usa",
  ],
  [
    "/hos2.svg",
    "Windows Shared Hosting",
    "Shared hosting built for ASP.NET and Windows apps.",
 
    "/windows-shared-hosting-usa",
  ],
  [
    "/ad2.svg", 
    "SSL", 
    "Secure your website with trusted SSL.",   
    "/ssl"], 
  ["/ad5.svg", "Apple Mac Servers", "Mac Mini servers for development.",  "/apple-mac-mini-m2-usa"],
  ["/ad6.svg", "Linux VPS", "Fast & secure Linux VPS hosting.",   "/linux-virtual-private-server-vps-usa"],
  ["/ad7.svg", "Windows VPS", "Optimized Windows VPS hosting.",  "/windows-virtual-private-server-vps-usa"],
  ["/ad8.svg", "Windows RDP Servers", "High-speed RDP servers.",     "/windows-remote-desktop-usa"],
  ["/ad9.svg", "SEO RDP / VPS", "Multi-IP VPS hosting optimized for SEO.", "/seo-rdpvps"],
];

/* ---------------------------------------------------------
   SOLUTIONS
--------------------------------------------------------- */

const applicationHosting: [string, string, string][] = [
  ["/sol1.svg", "Managed Wordpress Cloud", "/managed-wordpress-cloud-hosting"],
  ["/sol2.svg", "Managed Magento Cloud", "/managed-magento-cloud-hosting"],
  ["/sol3.svg", "Managed PHP Cloud", "/managed-php-cloud-hosting"],
  ["/sol4.svg", "Managed Laravel Cloud", "/managed-laravel-cloud-hosting"],
  ["/sol5.svg", "Managed Drupal Cloud", "/managed-drupal-cloud-hosting"],
  ["/sol6.svg", "Managed Joomla Cloud", "/managed-joomla-cloud-hosting"],
  ["/sol7.svg", "Managed Prestashop Cloud", "/managed-prestashop-cloud-hosting"],
  ["/sol8.svg", "Managed WooCommerce Cloud", "/managed-woocommerce-cloud-hosting"],
  ["/sol9.svg", "Managed Odoo Hosting", "/managed-odoo-hosting"],
  ["/sol10.svg", "Managed OpenCart Hosting", "/managed-opencart-hosting"],
];

const databaseHosting: [string, string, string][] = [
  ["/sol11.svg", "Managed MySQL Hosting", "/managed-mysql-hosting"],
  ["/sol12.svg", "Managed Redis Hosting", "/managed-redis-hosting"],
  ["/sol13.svg", "Managed MongoDB Hosting", "/managed-mongodb-hosting"],
  ["/sol14.svg", "Managed MariaDB Hosting", "/managed-mariadb-hosting"],
  ["/sol15.svg", "Managed Oracle Hosting", "/managed-oracle-hosting"],
  ["/sol16.svg", "Managed PostgreSQL Hosting", "/managed-postgresql-hosting"],
  ["/sol17.svg", "Managed Elasticsearch Hosting", "/managed-elasticsearch-hosting"],
  ["/sol18.svg", "Managed Kafka Hosting", "/managed-kafka-hosting"],
  ["/sol19.svg", "Managed Prometheus Hosting", "/managed-prometheus-hosting"],
];

const cloudHosting: [string, string, string][] = [
  ["/sol20.svg", "Managed DigitalOcean Cloud", "/managed-digitalocean-hosting"],
  ["/sol21.svg", "Managed Amazon Cloud (AWS)", "/managed-amazon-cloud-hosting"],
  ["/sol22.svg", "Managed Hyper-V Cloud Hosting", "/managed-hyper-v-cloud-hosting"],
  ["/sol23.svg", "Managed Kubernetes Hosting", "/managed-kubernetes-hosting"],
];

/* ---------------------------------------------------------
   DOMAINS MENU (NEW)
--------------------------------------------------------- */
const domainsMenu: [string, string, string][] = [
  ["/pr2.svg", "/domain-registrations", "Domain Registrations"],
  ["/pr2.svg", "/international-domains", "International Domains"],
  ["/pr2.svg", "/bulk-registration", "Bulk Registration"],
  ["/pr2.svg", "https://clients.temok.com/cart.php?a=add&domain=transfer", "Bulk Transfer"],
  ["/pr2.svg", "https://clients.temok.com/cart.php?a=add&domain=transfer", "Domain Transfer"],
  ["/pr2.svg", "/domain-pricing", "Domain Pricing"],
  ["/pr2.svg", "https://clients.temok.com/index.php?rp=/login", "Domain Renewals"],
];

/* ---------------------------------------------------------
   RESOURCES MENU
--------------------------------------------------------- */
const resourcesMenu: [string, string, string][] = [
  ["/reso1.svg", "/about-us", "About Us"],
  ["/reso2.svg", "/contact-us", "Contact Us"],
  ["/reso3.svg", "/privacy-policy", "Privacy Policy"],
  ["/reso3.svg", "/terms-of-use", "Terms & Conditions"],
  ["/reso5.svg", "/dmca", "DMCA"],
  ["/reso6.svg", "/blog", "Blog"],
  ["/reso7.svg", "https://www.shareasale.com/shareasale.cfm?merchantID=68808", "Affiliates"],
];



/* ---------------------------------------------------------
   PARTNERSHIPS
--------------------------------------------------------- */
const partnershipsMenu: [string, string, string][] = [
  ["/reso7.svg", "https://partners.temok.com/", "Reseller Partner Program"], 
  ["/reso2.svg", "https://partners.temok.com/whitelabel-managed-service-providers", "WhiteLabel Managed Service Providers"],
  ["/reso6.svg", "https://partners.temok.com/affiliates-program", "Affiliate Program"],
 
];

const aiHostingMenu: MegaMenuItem[] = [
  // [aiHostingIcon, "AI Hosting", "All AI deployment solutions", "/ai-hosting"],
  [whisperIcon, "Whisper Hosting", "Speech-to-text AI", "/whisper-hosting"],
  [openaiIcon, "Chatgpt Hosting", "AI chatbot deployment", "/chatgpt-hosting"],  
  [fluxHostingIcon, "Flux Hosting", "Image model inference", "/flux-hosting"], 
  [ollamaIcon, "Ollama Hosting", "Local LLM inference", "/ollama-hosting"],
  [openaiIcon, "GPT OSS Hosting", "Open model deployment", "/gpt-oss-hosting"], 
  [vllmIcon, "vLLM Hosting", "High-throughput inference", "/vllm-hosting"],
  [lmStudioIcon, "LM Studio Hosting", "Desktop LLM runtime", "/lm-studio-hosting"],
  [deepseekIcon, "DeepSeek Hosting", "DeepSeek AI models", "/deepseek-hosting"],
  [llamaIcon, "LLaMA Hosting", "Meta LLaMA models", "/llama-hosting"],
  [gemmaIcon, "Gemma Hosting", "Google Gemma models", "/gemma-hosting"],
  [qwenIcon, "Qwen Hosting", "Alibaba Qwen models", "/qwen-hosting"],
  [qwen3Icon, "Qwen3-VL Hosting", "Vision-language models", "/qwen3-vl-hosting"],
  [mistralIcon, "Mistral Hosting", "Mistral open models", "/mistral-hosting"],
  [phiIcon, "Phi Hosting", "Microsoft Phi models", "/phi-hosting"],
];

const gpuServersMenu: MegaMenuItem[] = [
  // [gpuServerIcon, "GPU Servers", "Dedicated AI GPU servers", "/gpu-servers"],
  [tensorflowIcon, "TensorFlow Hosting", "ML workloads on GPU", "/tensorflow-hosting"],
  [pytorchIcon, "PyTorch GPU Hosting", "Training & inference", "/pytorch-gpu-hosting"],
  [kerasIcon, "Keras GPU Hosting", "Deep learning workloads", "/keras-gpu-hosting"],
  [wanIcon, "WAN Hosting", "Distributed AI workloads", "/wan-hosting"],

  // 🔽 TTS moved here for balance


  [stableDiffusionIcon, "Stable Diffusion", "Image generation AI", "/stable-diffusion-hosting"],
  [comfyUIIcon, "ComfyUI Hosting", "Diffusion UI pipelines", "/comfyui-hosting"],
  [paddleOCRIcon, "PaddleOCR Hosting", "OCR & document AI", "/paddleocr-hosting"],

  [milvusIcon, "Milvus Hosting", "Vector database", "/milvus-hosting"],
  [chromaIcon, "ChromaDB Hosting", "Embedding storage", "/chromadb-hosting"],
  [qdrantIcon, "Qdrant Hosting", "Vector search engine", "/qdrant-hosting"],
];


const mediaAiMenu: MegaMenuItem[] = [
  // [ttsHostingIcon, "TTS Hosting", "Text-to-speech solutions", "/tts-hosting"],
  [barkIcon, "TTS Hosting", "Text-to-speech solutions", "/tts-hosting"],
  [barkIcon, "Bark Hosting", "Neural audio generation", "/bark-hosting"],
  [coquiIcon, "Coqui TTS Hosting", "Open-source TTS", "/coqui-tts-hosting"],
  [chatterboxIcon, "Chatterbox TTS", "Conversational speech", "/chatterbox-tts-hosting"], 
  [xttsIcon, "XTTS-v2 Hosting", "Cross-language neural TTS", "/xtts-v2-hosting"],
  [kokoroIcon, "Kokoro TTS Hosting", "Natural voice models", "/kokoro-tts-hosting"],
];



/* ---------------------------------------------------------
   NAVBAR COMPONENT
--------------------------------------------------------- */

export default function NavbarSection() { 

  const [isMobile, setIsMobile] = useState(false);
  const [open, setOpen] = useState({
    products: false,
    solutions: false,
    domains: false,
    resources: false,
    partnerships: false,
      ai: false, // ✅ NEW
  });

  const [expanded, setExpanded] = useState({
    products: false,
    solutions: false,
    domains: false,
    resources: false,
    partnerships: false,
      ai: false, // ✅ NEW
  });

  // const toggle = (key: "products" | "solutions" | "domains" | "resources" | "partnerships") =>
  //   setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  const toggle = (
    key: "ai" | "products" | "solutions" | "domains" | "resources" | "partnerships"
  ) => {
    // Mobile/tablet: only one menu open at a time
    if (isMobile) {
      setOpen({
        products: false,
        solutions: false,
        domains: false,
        resources: false,
        ai: false, // ✅ NEW
        partnerships: false,
        [key]: !open[key],
      });
    } else {
      // Desktop hover: normal toggle behavior
      setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
    }
  };
  

  const handleLoadMoreToggle = (key: "ai" |  "products" | "solutions" | "domains" | "resources" | "partnerships") =>
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth < 992);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <>
      <div className={styles.navbarWrapper}>
        <Navbar expand="xl" className={styles.navbar}>
          <Container>
            {/* LOGO */}
            <Link href="/" className={styles.logoWrapper}>
              <Image src={Logo} alt="Temok" width={120} height={34} />
            </Link>

            {/* MOBILE TOGGLE */}
            <Navbar.Toggle
              aria-controls="mobile-offcanvas"
              className={styles.toggle}
            />

            {/* OFFCANVAS */}
            <Navbar.Offcanvas
              id="mobile-offcanvas"
              placement="end"
              className={styles.offcanvas}
            >
              <Offcanvas.Header closeButton>
                <Image src={Logo} alt="Temok" width={120} height={34} />
              </Offcanvas.Header>

              <Offcanvas.Body>
                <Nav className={`mx-auto ${styles.navLinks}`}>
                   {/* AI */}
           {/* AI */}
         {/* AI */}
<div
  className={styles.dropdownWrapper}
  onMouseEnter={!isMobile ? () => toggle("ai") : undefined}
  onMouseLeave={!isMobile ? () => toggle("ai") : undefined}
>
  <span
    className={`${styles.dropdownTitle} ${open.ai ? "active" : ""}`}
    onClick={() => toggle("ai")}
  >
    AI <FaAngleDown className={styles.arrowIcon} />
  </span>

  {open.ai && (
    <div className={isMobile ? styles.megaMenuSmall : styles.megaMenu}>
      <div className={styles.smallInner}>
        <div className={isMobile ? styles.smallBox : styles.megaCard}>

          {/* ================= PRIMARY HUB ROW ================= */}
          <div className={styles.primaryHubRow}>
            <Link href="/ai-hosting" className={styles.primaryHubCard}>
              <Image src={aiHostingIcon} width={34} height={34} alt="AI Hosting" />
              <div>
                <h3>AI Hosting</h3>
                <p>All AI deployment solutions</p>
              </div>
            </Link>

            <Link href="/gpu-servers" className={styles.primaryHubCard}>
              <Image src={gpuServerIcon} width={34} height={34} alt="GPU Servers" />
              <div>
                <h3>GPU Servers</h3>
                <p>Dedicated AI GPU servers</p>
              </div>
            </Link>

            <Link href="/llm-hosting" className={styles.primaryHubCard}>
              <Image src={llMIcon} width={34} height={34} alt="LLM Hosting" />
              <div>
                <h3>LLM Hosting</h3>
                <p>Local LLM inference</p>
              </div>
            </Link>
          </div>
          {/* ================= END PRIMARY HUB ROW ================= */}

          {/* ================= SECONDARY GRID ================= */}
          <div className={styles.megaGrid}>

            {/* COLUMN 1 — AI MODELS */}
            <div>
              <p className={styles.megaHeading}>AI Models</p>

              {(expanded.ai ? aiHostingMenu : aiHostingMenu.slice(0, 5)).map(
                ([icon, title, desc, url]) => (
                  <Link
                    key={title}
                    href={url}
                    className={`${styles.megaItem} text-decoration-none`}
                  >
                    <Image src={icon} width={26} height={26} alt={title} />
                    <div>
                      <h4>{title}</h4>
                      <p>{desc}</p>
                    </div>
                  </Link>
                )
              )}
            </div>

            {/* COLUMN 2 — GPU & FRAMEWORKS */}
            <div>
              <p className={styles.megaHeading}>GPU & Frameworks</p>

              {(expanded.ai ? gpuServersMenu : gpuServersMenu.slice(0, 5)).map(
                ([icon, title, desc, url]) => (
                  <Link
                    key={title}
                    href={url}
                    className={`${styles.megaItem} text-decoration-none`}
                  >
                    <Image src={icon} width={26} height={26} alt={title} />
                    <div>
                      <h4>{title}</h4>
                      <p>{desc}</p>
                    </div>
                  </Link>
                )
              )}
            </div>

            {/* COLUMN 3 — TTS & MEDIA AI */}
            <div>
              <p className={styles.megaHeading}>TTS & Media AI</p>

              {(expanded.ai ? mediaAiMenu : mediaAiMenu.slice(0, 5)).map(
                ([icon, title, desc, url]) => (
                  <Link
                    key={title}
                    href={url}
                    className={`${styles.megaItem} text-decoration-none`}
                  >
                    <Image src={icon} width={26} height={26} alt={title} />
                    <div>
                      <h4>{title}</h4>
                      <p>{desc}</p>
                    </div>
                  </Link>
                )
              )}
            </div>

          </div>
          {/* ================= END SECONDARY GRID ================= */}

          {/* LOAD MORE */}
          {(aiHostingMenu.length > 5 ||
            gpuServersMenu.length > 5 ||
            mediaAiMenu.length > 5) && (
            <div className={styles.loadMoreWrapper}>
              <button
                type="button"
                className={styles.loadMoreBtn}
                onClick={() => handleLoadMoreToggle("ai")}
              >
                {expanded.ai ? "Show Less" : "Load More"}
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  )}
</div>


                  {/* PRODUCTS */}
                  <div
                    className={styles.dropdownWrapper}
                    onMouseEnter={!isMobile ? () => toggle("products") : undefined}
                    onMouseLeave={!isMobile ? () => toggle("products") : undefined}
                  >
                    <span
                      className={`${styles.dropdownTitle} ${
                        open.products ? "active" : ""
                      }`}
                      onClick={() => toggle("products")}
                    >
                      Products <FaAngleDown className={styles.arrowIcon} />
                    </span>

                    {open.products && (
                      <div
                        className={
                          isMobile ? styles.megaMenuSmall : styles.megaMenu
                        }
                      >
                        <div className={styles.smallInner}>
                          <div
                            className={isMobile ? styles.smallBox : styles.megaCard}
                          >
                            <div className={styles.megaGrid}>
                              {/* Column 1 */}
                              <div>
                                <p className={styles.megaHeading}>
                                  Infrastructure Hosting
                                </p>

                                {(expanded.products
                                  ? infraHosting
                                  : infraHosting.slice(0, 4)
                                ).map(([icon, title, desc, tag, url = "#"]) => (
                                  <Link
                                    href={url}
                                    key={title}
                                    className={`${styles.megaItem} text-decoration-none`}
                                  >
                                    <Image src={icon} width={28} height={28} alt="" />
                                    <div>
                                      <h4>
                                        {title}
                                        {tag && (
                                          <span
                                            className={
                                              tag === "NEW"
                                                ? styles.badgeGreen
                                                : styles.badgeBlue
                                            }
                                          >
                                            {tag}
                                          </span>
                                        )}
                                      </h4>
                                      <p>{desc}</p>
                                    </div>
                                  </Link>
                                ))}
                              </div>

                              {/* Column 2 */}
                              <div>
                                <p className={styles.megaHeading}>
                                  Networking
                                </p>

                                {(expanded.products
                                  ? networking
                                  : networking.slice(0, 4)
                                ).map(([icon, title, desc, url]) => (
                                  <Link
                                    href={url}
                                    key={title}
                                    className={`${styles.megaItem} text-decoration-none`}
                                  >
                                    <Image src={icon} width={28} height={28} alt="" />
                                    <div>
                                      <h4>{title}</h4>
                                      <p>{desc}</p>
                                    </div>
                                  </Link>
                                ))}
                              </div>

                              {/* Column 3 */}
                              <div>
                                <p className={styles.megaHeading}>
                                  Apps & Servers
                                </p>

                                {(expanded.products ? apps : apps.slice(0, 4)).map(
                                  ([icon, title, desc, url]) => (
                                    <Link
                                      href={url}
                                      key={title}
                                      className={`${styles.megaItem} text-decoration-none`}
                                    >
                                      <Image src={icon} width={28} height={28} alt="" />
                                      <div>
                                        <h4>{title}</h4>
                                        <p>{desc}</p>
                                      </div>
                                    </Link>
                                  )
                                )}
                              </div>
                            </div>

                            {(
                              infraHosting.length > 4 ||
                              networking.length > 4 ||
                              apps.length > 4
                            ) && (
                              <div className={styles.loadMoreWrapper}>
                                <button
                                  type="button"
                                  className={styles.loadMoreBtn}
                                  onClick={() => handleLoadMoreToggle("products")}
                                >
                                  {expanded.products ? "Show Less" : "Load More"}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* SOLUTIONS */}
                  <div
                    className={styles.dropdownWrapper}
                    onMouseEnter={!isMobile ? () => toggle("solutions") : undefined}
                    onMouseLeave={!isMobile ? () => toggle("solutions") : undefined}
                  >
                    <span
                      className={`${styles.dropdownTitle} ${
                        open.solutions ? "active" : ""
                      }`}
                      onClick={() => toggle("solutions")}
                    >
                      Solutions <FaAngleDown className={styles.arrowIcon} />
                    </span>

                    {open.solutions && (
                      <div className={styles.megaMenuSolutions}>
                        <div className={styles.innerContainer}>
                          <div className={styles.megaSolutionsCard}>
                            <div className={styles.megaSolutionsGrid}>
                              {/* Application Hosting */}
                              <div>
                                <p className={styles.megaHeading}>Application Hosting</p>

                                {(expanded.solutions
                                  ? applicationHosting
                                  : applicationHosting.slice(0, 4)
                                ).map(([icon, title, url]) => (
                                  <Link
                                    href={url}
                                    key={title}
                                    className={`${styles.megaItem} text-decoration-none`}
                                  >
                                    <Image src={icon} width={28} height={28} alt="" />
                                    <div>
                                      <h4>{title}</h4>
                                      <p>Fully managed. Optimized.</p>
                                    </div>
                                  </Link>
                                ))}
                              </div>

                              {/* Database Hosting */}
                              <div>
                                <p className={styles.megaHeading}>Database Hosting</p>

                                {(expanded.solutions
                                  ? databaseHosting
                                  : databaseHosting.slice(0, 4)
                                ).map(([icon, title, url]) => (
                                  <Link
                                    href={url}
                                    key={title}
                                    className={`${styles.megaItem} text-decoration-none`}
                                  >
                                    <Image src={icon} width={28} height={28} alt="" />
                                    <div>
                                      <h4>{title}</h4>
                                      <p>Fully managed DB clusters.</p>
                                    </div>
                                  </Link>
                                ))}
                              </div>

                              {/* Cloud Hosting */}
                              <div>
                                <p className={styles.megaHeading}>Cloud Hosting</p>

                                {(expanded.solutions
                                  ? cloudHosting
                                  : cloudHosting.slice(0, 4)
                                ).map(([icon, title, url]) => (
                                  <Link
                                    href={url}
                                    key={title}
                                    className={`${styles.megaItem} text-decoration-none`}
                                  >
                                    <Image src={icon} width={28} height={28} alt="" />
                                    <div>
                                      <h4>{title}</h4>
                                      <p>Fully managed cloud environments.</p>
                                    </div>
                                  </Link>
                                ))}
                              </div>
                            </div>

                            {(
                              applicationHosting.length > 4 ||
                              databaseHosting.length > 4 ||
                              cloudHosting.length > 4
                            ) && (
                              <div className={styles.loadMoreWrapper}>
                                <button
                                  type="button"
                                  className={styles.loadMoreBtn}
                                  onClick={() => handleLoadMoreToggle("solutions")}
                                >
                                  {expanded.solutions ? "Show Less" : "Load More"}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* DOMAINS — NEW DROPDOWN */}
                  <div
                    className={styles.dropdownWrapper}
                    onMouseEnter={!isMobile ? () => toggle("domains") : undefined}
                    onMouseLeave={!isMobile ? () => toggle("domains") : undefined}
                  >
                    <span
                      className={`${styles.dropdownTitle} ${
                        open.domains ? "active" : ""
                      }`}
                      onClick={() => toggle("domains")}
                    >
                      Domains <FaAngleDown className={styles.arrowIcon} />
                    </span>

                    {open.domains && (
                      <div className={styles.megaMenuSmall}>
                        <div className={styles.smallInner}>
                          <div className={styles.smallBox}>
                            {(expanded.domains
                              ? domainsMenu
                              : domainsMenu.slice(0, 4)
                            ).map(([icon, url, label]) => (
                              <Link
                                href={url}
                                key={label}
                                className={`${styles.megaItem} text-decoration-none`}
                              >
                                <Image src={icon} width={22} height={22} alt={label} />
                                <div>
                                  <h4>{label}</h4>
                                  <p>Manage {label.toLowerCase()}.</p>
                                </div>
                              </Link>
                            ))}

                            {domainsMenu.length > 4 && (
                              <div className={styles.loadMoreWrapper}>
                                <button
                                  type="button"
                                  className={styles.loadMoreBtn}
                                  onClick={() => handleLoadMoreToggle("domains")}
                                >
                                  {expanded.domains ? "Show Less" : "Load More"}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* PARTNERSHIPS */}
                  <div
                    className={styles.dropdownWrapper}
                    onMouseEnter={!isMobile ? () => toggle("partnerships") : undefined}
                    onMouseLeave={!isMobile ? () => toggle("partnerships") : undefined}
                  >
                    <span
                      className={`${styles.dropdownTitle} ${
                        open.partnerships ? "active" : ""
                      }`}
                      onClick={() => toggle("partnerships")}
                    >
                      Partnerships <FaAngleDown className={styles.arrowIcon} />
                    </span>

                    {open.partnerships && (
                      <div className={styles.megaMenuSmall}>
                        <div className={styles.smallInner}>
                          <div className={styles.smallBox}>
                            {(expanded.partnerships
                              ? partnershipsMenu
                              : partnershipsMenu.slice(0, 4)
                            ).map(([icon, url, label]) => (
                              <Link
                                href={url}
                                key={label}
                                className={`${styles.megaItem} text-decoration-none`}
                              >
                                <Image src={icon} width={22} height={22} alt={label} />
                                <div>
                                  <h4>{label}</h4>
                                  <p>Learn more about {label.toLowerCase()}.</p>
                                </div>
                              </Link>
                            ))}

                            {partnershipsMenu.length > 4 && (
                              <div className={styles.loadMoreWrapper}>
                                <button
                                  type="button"
                                  className={styles.loadMoreBtn}
                                  onClick={() => handleLoadMoreToggle("partnerships")}
                                >
                                  {expanded.partnerships ? "Show Less" : "Load More"}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* RESOURCES */}
                  <div
                    className={styles.dropdownWrapper}
                    onMouseEnter={!isMobile ? () => toggle("resources") : undefined}
                    onMouseLeave={!isMobile ? () => toggle("resources") : undefined}
                  >
                    <span
                      className={`${styles.dropdownTitle} ${
                        open.resources ? "active" : ""
                      }`}
                      onClick={() => toggle("resources")}
                    >
                      Resources <FaAngleDown className={styles.arrowIcon} />
                    </span>

                    {open.resources && (
                      <div className={styles.megaMenuSmall}>
                        <div className={styles.smallInner}>
                          <div className={styles.smallBox}>
                            {(expanded.resources
                              ? resourcesMenu
                              : resourcesMenu.slice(0, 4)
                            ).map(([icon, url, label]) => (
                              <Link
                                href={url}
                                key={label}
                                className={`${styles.megaItem} text-decoration-none`}
                              >
                                <Image src={icon} width={22} height={22} alt={label} />
                                <div>
                                  <h4>{label}</h4>
                                  <p>Learn more about {label.toLowerCase()}.</p>
                                </div>
                              </Link>
                            ))}

                            {resourcesMenu.length > 4 && (
                              <div className={styles.loadMoreWrapper}>
                                <button
                                  type="button"
                                  className={styles.loadMoreBtn}
                                  onClick={() => handleLoadMoreToggle("resources")}
                                >
                                  {expanded.resources ? "Show Less" : "Load More"}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  
                </Nav>

                {/* RIGHT SECTION */}
                <Nav className={styles.rightSection}>
                  <Link
                    href="https://clients.temok.com/login.php"
                    className={`${styles.loginLink} text-decoration-none`}
                  >
                    Log in
                  </Link>

                  <Link href="https://clients.temok.com/register.php">
                    <Button className={styles.getStarted}>Get Started</Button>
                  </Link>
                  <Link
        href="https://ai.temok.com"
        target="_blank"
        className={`${styles.button} btn-lg `}
      >
         <Sparkles size={18} /> Temok AI Advisor
      </Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </div>
    </>
  );
}
